import VuetifyPhoneNumberInput from '@/components/external-components/vuetify-phone-number-input/vuetify-phone-number-input.vue';
export default {
    components : {
        VuetifyPhoneNumberInput,
    },
    props: {
        placeholder:  {
            type    : String,
            default : "Enter a phone number"
        },
        required   :  {
            type    : Boolean,
            default : false
        },
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data: () => ({
        phone: {
            number  : '',
            valid   : false,
            country : undefined,
        },
        regionCode : 'CH',
        bindProps: {
            defaultCountry          : "CH",
            onlyCountries           :  ["CH", "IT", "FR", "DE", "AT", "LI"],
            // mode                    : "international",  //international: Ex: +41 || national Ex: 07..
            mode                    : "international",
            disabledFetchingCountry : false,
            disabled                : false,
            disabledFormatting      : false,
            required                : true,
            enabledFlags            : true,
            ignoredCountries        : [],
            autocomplete            : "on", //off
            name                    : "number",
            maxLen                  : 25,
            dropdownOptions         : { disabledDialCode: true, tabindex: 0 },
            inputOptions            : { showDialCode: false, tabindex: 0 },
            enabledCountryCode      : false,
            validCharactersOnly     : true,
        }
    }),
    methods: {
        validate() {
            return this.$refs.phoneInput.validate();
        },
        onCountryChange(obj) {
            this.regionCode = obj.iso2;
        },
        onValidate(obj) {
            this.phone.number   = obj.number.international;
            this.phone.valid    = obj.valid;
            this.phone.country  = obj.country && obj.country.name;
        },
        onInput(formattedNumber, { number, valid, country }) {
            this.phone.number   = number.international;
            this.phone.valid    = valid;
            this.phone.country  = country && country.name;
        },
        setValue(value)  {
            this.phone.number = value;
        },
        getValue()  {
            return this.phone.number;
        },
    },
    watch: {
        placeholder: function(val) {
            this.placeholder = val;
        }
    },
    computed: {
        hint(){
            let hint = '';
            switch(this.regionCode) {
                case 'CH':
                    hint = 'Ex: +41 70 000 00 00';
                    return hint;
                    break;
                case 'IT':
                    hint = 'Ex: +39 123 45 67 89';
                    return hint;
                    break;
                case 'FR':
                    hint = 'Ex: +33 123 45 67 89';
                    return hint;
                    break;
                case 'DE':
                    hint = 'Ex: +49 123 45 67 89';
                    return hint;
                    break;
                case 'AT':
                    hint = 'Ex: +43 123 45 67 89';
                    return hint;
                    break;
                case 'LI':
                    hint = 'Ex: +423 123 45 67 89';
                    return hint;
                    break;
                default:
                    hint = 'Ex: +41 00 000 00 00';
                    return hint;
            }
        }
    }
};
